import { Navigate } from 'react-router';

const RedirectToDefault = () => {
  return (
    <Navigate
      replace
      to="/datastream/packagemanager"
    />
  );
};

export default RedirectToDefault;
